import { hash } from '@ember/helper';

import HcpMarketingMain from 'hcp/components/hcp-marketing/main';
import HcpMarketingAside from 'hcp/components/hcp-marketing/aside';

const HcpMarketing = <template>
  <div class="hcp-marketing" ...attributes>
    {{yield (hash Main=HcpMarketingMain Aside=HcpMarketingAside)}}
  </div>
</template>;

export default HcpMarketing;
